var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4 3.6H3.6V2.7001H1.8V5.4H16.2V2.7001H14.4V3.6H12.6V2.7001H5.4V3.6ZM1.8 16.2001V7.2H16.2V16.2001H1.8ZM12.6 0.9H5.4V0H3.6V0.9H1.8C0.805887 0.9 0 1.70589 0 2.7V16.2C0 17.1941 0.805887 18 1.8 18H16.2C17.1941 18 18 17.1941 18 16.2V2.7C18 1.70589 17.1941 0.9 16.2 0.9H14.4V0H12.6V0.9ZM11.9637 8.36367L8.10007 12.2273L6.03646 10.1637L4.76367 11.4365L8.10007 14.7729L13.2365 9.63646L11.9637 8.36367Z",
    fill: "#626262"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c30669304c8802089b8f296033ef880a.svg";
export { ForwardRef as ReactComponent };